import initialState from '../../initialState';
import * as actionTypes from '../../../actions/actionTypes';

export default function hubPastEnrolmentsPageReducer(state = initialState.ui.apiState.hubPastEnrolmentsPage, action) {
  switch (action.type) {
    case actionTypes.HUB_EP_FETCH_PAST_ENROLMENTS_START:
      return {
        ...state,
        fetchError: false,
        isLoading: true,
      };
    case actionTypes.HUB_EP_FETCH_PAST_ENROLMENTS_SUCCESS:
      return {
        ...state,
        fetchError: false,
        isLoading: false,
        hasFetched: true,
      };
    case actionTypes.HUB_EP_FETCH_PAST_ENROLMENTS_FAILED:
      return {
        ...state,
        fetchError: true,
        isLoading: false,
      };
    case actionTypes.HUB_EP_FETCH_PAST_ENROLMENTS_FAILURE_DEFINITIVE:
      return {
        ...state,
        retryEnabled: false,
        fetchError: true,
        isLoading: false,
      };
    default:
      return state;
  }
}
